import moment from "moment";
import { s3AutomationPrivate } from "./aws";
import {
  uploadFileToS3, getUser, getFileFromS3, getAppVersion, convertUnit8ArrayToJson,
} from "./helpers";
import { API_URL, API_URL_SQL } from "./Constant";

export const logEndpoints = [
  {
    endpoint: `${API_URL}/send_report_server/`,
    parentFolder: "media/automation/logs/send_reports/",
    dateFormat: "YYYY-MM",
    dropdownLabel: "Send Reports",
  },
  {
    endpoint: `${API_URL}/generatebatchreports/`,
    parentFolder: "media/automation/logs/batch_reports/",
    dateFormat: "YYYY/MM/DD",
    dropdownLabel: "Batch Reports",
  },
  {
    endpoint: `${API_URL}/editcustomerinsample/`,
    parentFolder: "media/automation/logs/batch_reports/",
    dateFormat: "YYYY/MM/DD",
    dropdownLabel: "Batch Reports",
  },
  {
    endpoint: `${API_URL}/editsample/`,
    parentFolder: "media/automation/logs/batch_reports/",
    dateFormat: "YYYY/MM/DD",
    dropdownLabel: "Batch Reports",
  },
  {
    endpoint: `${API_URL_SQL}/migrate/`,
    parentFolder: "media/automation/logs/migrate/",
    dateFormat: "YYYY-MM",
    dropdownLabel: "Migrate",
  },
  {
    // With any result update, ml qc will be called, and this api payload and responses are being logged. The API is called by backend
    parentFolder: "media/automation/logs/ml_qc_detect-errors_api/",
    dateFormat: "YYYY/MM/DD",
    dropdownLabel: "ML QC",
  },
  {
    // With any test ML rule action, detect-error_api_rule_check/ will be called, and this api payload and responses are being logged.
    parentFolder: "media/automation/logs/ml_qc_detect-error_api_rule_check/",
    dateFormat: "YYYY/MM/DD",
    dropdownLabel: "ML QC Rule Test",
  },
  {
    // The API is called by backend
    parentFolder: "media/automation/logs/process-petrifilms_api/",
    dateFormat: "YYYY/MM/DD",
    dropdownLabel: "Process Petrifilms",
  },
  {
    parentFolder: "media/automation/logs/ml_excel_process/",
    dateFormat: "YYYY/MM/DD",
    dropdownLabel: "Chem ML Excel",
  },
];

/**
 * Create the s3 path based on the api endpoint and the date format
 */
const createS3JsonFileKey = (requestResponse) => {
  const { parentFolder, dateFormat } = logEndpoints.find((endpoint) => requestResponse.config.url.includes(endpoint.endpoint));
  let key = "";
  if (!parentFolder || !dateFormat) {
    return key;
  }
  key = `${parentFolder}${moment().format(dateFormat)}.json`;
  return key;
};

/**
 * Append the new data to the current json file
 * @param {*} jsonKey json file path
 * @param {*} rawData exited json date
 * @param {*} payload api payload
 * @param {*} response api response
 */
const appendDataToS3JsonFile = async (jsonKey, rawData, payload, response) => {
  let currentDayData = convertUnit8ArrayToJson(rawData);
  const userDetails = getUser();
  const newData = {
    time: moment().format("MM/DD/YYYY, h:mm:ss a"),
    user: userDetails.email,
    role: userDetails.role,
    version: getAppVersion(),
    app: "MySql",
    payload,
    response,
  };
  currentDayData.unshift(newData);
  currentDayData = JSON.stringify(currentDayData);
  const file = new Blob([currentDayData], { type: "application/json" });
  const fileObj = {
    file,
    key: jsonKey,
    type: "application/json",
  };
  await uploadFileToS3(fileObj, s3AutomationPrivate);
};

/**
 * Create an new json file
 * @param {*} jsonKey json file path
 * @param {*} payload api payload
 * @param {*} response api response
 */
const createNewS3JsonFile = async (jsonKey, payload, response) => {
  const userDetails = getUser();
  const jsonData = JSON.stringify([{
    time: moment().format("MM/DD/YYYY, h:mm:ss a"),
    user: userDetails.email,
    role: userDetails.role,
    version: getAppVersion(),
    app: "MySql",
    payload,
    response,
  }]);
  const file = new Blob([jsonData], { type: "application/json" });
  const fileObj = {
    file,
    key: jsonKey,
    type: "application/json",
  };
  await uploadFileToS3(fileObj, s3AutomationPrivate);
};

/**
 * Append the excel aws s3 path into a json file
 *  1. if there json does not exist, then create a new one
 *  2. if there json exists, then append the data to the current json file.
 * @param {*} excelPath excel aws s3 path
 * @param {*} excelFileName excel file name
 * @param {*} respArr responses from uploadcountsheets/ and rechecks/
 */
const uploadDataToS3Json = async (requestResponse) => {
  // Base case: if the endpoint is not in the logEndpoints, then return
  if (!logEndpoints.some((item) => requestResponse.config.url.includes(item.endpoint))) {
    return;
  }

  const jsonKey = createS3JsonFileKey(requestResponse);
  const key = requestResponse.config.method === "get" ? "params" : "data";
  let payload = requestResponse.config[key];
  if (typeof payload === "string") {
    payload = JSON.parse(payload);
  }
  let response = requestResponse.data;
  if (!response) {
    response = { code: requestResponse?.code, message: requestResponse?.message };
  }

  // Base case: if the skipS3Logging is true or the jsonKey is not found, then return
  if (!jsonKey || payload.skipS3Logging) {
    return;
  }

  const s3FileResponse = await getFileFromS3(jsonKey, s3AutomationPrivate);
  if (s3FileResponse.success) {
    appendDataToS3JsonFile(jsonKey, s3FileResponse.data, payload, response);
  } else if (s3FileResponse.errorCode === "NoSuchKey") {
    createNewS3JsonFile(jsonKey, payload, response);
  }
};

// check if the files exists on s3
// if it does not, create a file with a empty list then send the log to the backend
// if it does, just send the log to the backend
export const saveLogToS3 = async (requestResponse) => {
  try {
    await uploadDataToS3Json(requestResponse);
  } catch (e) {
    console.log("Failed to log batch report: ", e);
  }
};
